import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom"
import { GiHamburgerMenu } from "react-icons/gi"
import { IoMdClose } from "react-icons/io"
import { generalAssets } from '../../../assets/media'

const MobileMenu = () => {
    // const { logo, logoYellow } = generalAssets.brandLogo
    const { logo } = generalAssets.brandLogo
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const [mobileMenu, setmobileMenu] = useState(false)
    const navList = [
        {
            name: "Home",
            url: "/"
        },
        {
            name: "About Us",
            url: "/about"
        },
        {
            name: "Pricing",
            url: "/plans"
        },
        {
            name: "Test Library",
            url: "/test-library"
        },
        {
            name: "Contact",
            url: "/contact"
        },
    ]
    const handleNavItem = (url) => {
        setmobileMenu(false)
        navigate(url)

    }

    return (
        <div className=''>
            <div className="mobileMenu  flex justify-between px-5 lg:hidden">
                <Link to="/">
                    <img src={['/', '/test-library'].includes(pathname) ? logo : logo} className="w-44 object-contain" alt="logo" />
                </Link>
                <GiHamburgerMenu className='text-[2rem] cursor-pointer' onClick={() => setmobileMenu(true)} />
            </div>

            {

                <div className={`navAside  w-screen h-screen top-0 right-0 fixed bg-yellow-400 z-[1000] lg:hidden  transition-transform transform ${mobileMenu ? 'translate-x-0' : 'translate-x-full'}`}>
                    <div className="header border-b px-10 py-5 flex justify-between">
                        <IoMdClose className='text-[2rem]' onClick={() => setmobileMenu(false)} />
                    </div>

                    <nav className="navList">
                        <ul>
                            {
                                navList.map((navItem, index) =>
                                    <li key={index} onClick={() => handleNavItem(navItem.url)} className={`py-2 px-10 text-[1.5rem] hover:text-yellow-400 hover:bg-[#333333] cursor-pointer ${pathname === navItem.url ? '!bg-[#333] !text-yellow-400' : null}`}>{navItem.name}</li>
                                )
                            }
                            <li className='lg:ml-2'>
                                <a href="https://platform.thetalent.games" target='_blank'>
                                    <button className={`py-2 px-10 text-[1.5rem] hover:text-yellow-400 cursor-pointer null inline-flex items-center hover:decoration-solid hover:underline justify-center text-center transition-all delay-75`}>
                                        <span className="">Login</span>
                                    </button>
                                </a>
                            </li>
                        </ul>

                    </nav>
                </div>
            }
        </div>
    )
}

export default MobileMenu